<template>
  <div class="SubscriptionSuccessful">
    <confirmation-banner
      icon-name="tick-success"
      :title="$t('payment_thanks.paymentSuccessful.info', 'The payment was succesful.')"
      :description="$t('payment_thanks.paymentSuccessful.infoEmail', 'You will recieve a confirmation email shortly, please confirm and start shipment.Your subscription account')"
    />

    <div class="SubscriptionSuccessful_body">
      <div class="container">
        <div v-show="redirect"> 
        <div class="partnermessage" > {{this.banner.affiliatePartnerMessage}} </div>       
        <app-button class="redirecturl" v-on:click="manualredirect()">{{ $t('payment_thanks.paymentSuccessful.redirect', ' Click here to go to the partner website')}}  </app-button>  
        </div>
        <transition name="fade" mode="out-in" v-if="isLoading">
          <app-loading
            :is-loading="isLoading"
            :size="30"
          />
        </transition>

        <template v-if="!isFamilyPack">
          <div class="info info-product">
            <h2 class="title">
              {{ singleBundleContent.pretreatmentTitle }}
            </h2>

            <ul class="tips-product">
              <li v-for="(item, index) in singleBundleContent.paymentSuccessfulList" :key="index">
                <p v-html="item.text"></p>
              </li>
            </ul>
          </div>

          <div class="info info-promote" v-if="singleBundleContent.promoteApp">
            <div class="store-app">
              <a
                v-if="singleBundleContent.promoteApp.appStoreLink"
                :href="singleBundleContent.promoteApp.appStoreLink"
                target="_blank"
                @click="trackConversion({ name: 'interaction', description: 'img:appstore' })"
              >
                <img src="@/assets/images/appstore.jpg" alt="appstorep">
              </a>

              <a
                v-if="singleBundleContent.promoteApp.googlePlayLink"
                :href="singleBundleContent.promoteApp.googlePlayLink"
                target="_blank"
                @click="trackConversion({ name: 'interaction', description: 'img:google_play' })"
              >
                <img src="@/assets/images/google-play.jpg" alt="google-play">
              </a>
            </div>
          </div>
        </template>

        <template v-else>
          <div class="FamilyPackOverview">
            <p class="description">
              {{ $t('payment_thanks.familyPack.overview.description', "Thanks, we're on it! Your products will arrive soon") }}
            </p>
            <div class="row equal-item">
              <div class="col-md-6" v-for="(bundle, index) in familyPackOverview" :key="index">
                <product
                  :name="bundle.title"
                  :image="bundle.imageUrl"
                  :description="bundle.description"
                />
              </div>
            </div>
          </div>
        </template>
      </div>
      <span id='extole_zone_confirmation'> </span>
    </div>
  </div>
</template>

<script>
  import { detectedLanguageCode } from '@/utilities/common/culture'
  import ConfirmationBanner from 'components/ConfirmationBanner'
  import { mapState } from 'vuex'
  import Product from 'components/Product'
  import { extractErrorMessage } from '@/utilities/common'
  import Vue from 'vue'
  import { detectedCulture } from '@/utilities/common/culture'


  export default {
    name: 'subscription-successful',

    components: {
      ConfirmationBanner,
      Product
    },

    data () {
      return {
        isLoading: true,
        singleBundleContent: {},
        extoleZone: {},
        familyPackOverview: [],
        banner: {},
        isFamilyPack: false,
        detectedCulture: detectedCulture
      }
    },

    computed: {
      ...mapState('culture', ['thankYouScript', 'extoleCoreTagUrl']),
      ...mapState('account', {
        profile: state => state.profile 
      }),

      normalizedThankYouScript () {
        if (this.banner.script) {
          let thankYouScript = this.banner.script
          Object.entries(this.extoleZone).forEach(([key, value]) => {
            if (value || value === 0) {
              thankYouScript = thankYouScript.replace(new RegExp(`{{ ${key} }}`, 'g'), `"${value}"`)
            } else {
              thankYouScript = thankYouScript.replace(new RegExp(`{{ ${key} }}`, 'g'), null)
            }
          })
          return thankYouScript
        }
      },

    isthankyou () {
     return this.packingInfo.bundlesName.includes('sonicare-HX909211-q-6m-repl') || this.packingInfo.bundlesName.includes('sonicare-HX909210-q-6m-repl')|| this.packingInfo.bundlesName.includes('sonicare-HX904233-q-6m-repl') || this.packingInfo.bundlesName.includes('sonicare-HX904217-q-6m-repl') || this.packingInfo.bundlesName.includes('sonicare-HX905217-q-6m-repl') || this.packingInfo.bundlesName.includes ('sonicare-HX606213-q-6m-repl') || this.packingInfo.bundlesName.includes('sonicare-HX606210-q-6m-repl')
     },

      redirect(){ 
        if((this.banner.affiliatePartner === undefined) || (this.banner.affiliatePartner === null)){ 
          return false
        } else {
            if(this.banner.affiliatePartner !== 'NotApplicable'){
              setTimeout(() => {window.open (this.banner.affiliatePartnerRedirectUrl,'_blank') }, 6000); 
            return true
         } 
        } 
      }
    },

    metaInfo () {
      if (this.banner.script) {
        return {
          script: [
            {
              skip: !this.banner.script,
              type: 'text/javascript',
              innerHTML: this.normalizedThankYouScript,
              body: true
            },
            {
              skip: !this.banner.scriptUrl,
              src: this.banner.scriptUrl,
              async: true
            }
          ]
        }
      }
    },

    mounted(){
    const profile = JSON.parse(window.sessionStorage.getItem('profile'))
    const subscriptionInfo = JSON.parse(window.sessionStorage.getItem('subscriptionInfo')) 

            this.trackGoogleAnalyticsSimple({  
          trigger: 'subscriptions.checkout.orderConfirmation',
          event: 'ecommerceEvent',
          marketPlaceParticipant: 'Philips',
          ecommerce: {
            currencyCode: this.packingInfo.currencyCode,
           purchase: {
              actionField: {
                  id: this.packingInfo.orderNumber,
                  revenue: this.extoleZone.cartValue,
                  shipping: profile,
                  coupon: this.packingInfo.couponCode, 
                },

                 products: [
                { 
                  locale: this.detectedCulture.code, 
                  quantity: this.packingInfo.qty,
                  price: subscriptionInfo[0].price,
                  originalPrice: this.packingInfo.totalPrice,
                  coupon:this.packingInfo.couponCode,
                  ctn: this.packingInfo.ctn,                
                  bundleType: this.packingInfo.bundlesName,
                  isSubscription: this.profile.personalDetail.ableToSubscribe,
                  marketPlaceParticipant:this.detectedCulture.site ,
                }
                 ]
                
              }
            } 
        })
    },  

    methods: {
      async getSingleBundleContent (bundlesName) {
        try {
          const { results: bundleResults } = await this.$prismic.client.query(
            this.$prismic.Predicates.any('my.bundle.bundle_name', bundlesName),
            { lang: detectedLanguageCode }
          )

          const {
            promoteapp: promoteApp,
            pretreatment_title: pretreatmentTitle,
            payment_successful_list: paymentSuccessfulList
          } = bundleResults[0].data

          let normalizedPromoteApp
          if (promoteApp.length) {
            normalizedPromoteApp = {}
            promoteApp.forEach(item => {
              normalizedPromoteApp[item.key] = item.value
            })
          } else {
            normalizedPromoteApp = null
          }

          let paymentSuccessfulIds = []
          paymentSuccessfulList.forEach(item => {
            if (!item.key.id) return
            paymentSuccessfulIds.push(item.key.id)
          })
          const { results: paymentSuccessfulResults } = await this.$prismic.client.getByIDs(paymentSuccessfulIds)
          const normalizedPaymentSuccessfulList = paymentSuccessfulResults.reduce((acc, curr) => {
            return [...acc, ...curr.data.items]
          }, [])

          this.singleBundleContent = {
            pretreatmentTitle,
            promoteApp: normalizedPromoteApp,
            paymentSuccessfulList: normalizedPaymentSuccessfulList
          }
          this.isLoading = false
        } catch (error) {
          console.error(error)
        }
      },

      async getFamilyPackOverview (bundlesName) {
        try {
          const { results } = await this.$prismic.client.query(
            this.$prismic.Predicates.any('my.bundle.bundle_name', bundlesName),
            { lang: detectedLanguageCode }
          )

          this.familyPackOverview = results.map(({ data }) => ({
            title: data.bundle_title,
            imageUrl: data.bundle_image.url,
            description: data.bundle_description
          }))
          this.isLoading = false
        } catch (error) {
          console.error(error)
        }
      },
       manualredirect: function (event) {
          setTimeout(() => {window.open (this.banner.affiliatePartnerRedirectUrl,'_blank') }, 0); 
      }
    },

    created () {
      this.$store.commit('account/deleteOrder')
      window.localStorage.removeItem('bundlesInfor')
      window.localStorage.removeItem('storedCartItems')
      window.localStorage.removeItem('bundlesWithPromotions')
      window.localStorage.removeItem('currentEstimatedZipCode')

      const personalDetail = JSON.parse(window.sessionStorage.getItem('personalDetail'))
      const packingInfo = JSON.parse(window.sessionStorage.getItem('packingInfo'))
      const subscriptionInfo = JSON.parse(window.sessionStorage.getItem('subscriptionInfo'))

      this.packingInfo = packingInfo

      subscriptionInfo.forEach(item => {
        this.trackAjax({
          events: 'event111',
          products: `;${item.ctn};${item.quantity};${item.price};;frequency=${item.frequency}`
        })
      })

      this.extoleZone = {
        firstName: personalDetail.firstName,
        lastName: personalDetail.lastName,
        email: personalDetail.email,
        partnerUserId: personalDetail.uuid,
        partnerConversionId: packingInfo.orderNumber,
        cartValue: packingInfo.totalPrice,
        couponCode: packingInfo.couponCode
      }

      if (packingInfo.bundlesName.length > 1 && this.detectedCulture.countryCode !== 'FR' || packingInfo.bundlesName.length > 1 && this.detectedCulture.countryCode === 'FR' && this.isthankyou) {
        this.isFamilyPack = true
        this.getFamilyPackOverview(packingInfo.bundlesName)
      } else {
        this.getSingleBundleContent(packingInfo.bundlesName)
      }

      Vue.api.product.getBanners(packingInfo.bundlesName).then((banners) => {
        this.banner = banners.find(() => this.banner.affiliatePartner !== 'NotApplicable')
        if((this.banner.affiliatePartner === undefined) || (this.banner.affiliatePartner === null) ){
          return false
        } else {
          if(this.banner.affiliatePartner !== 'NotApplicable' ){
          return true
         } 
        }
        this.banner = banners.find((n) => n.script !== null || n.scriptUrl !== null)
        if (!this.banner) {
          this.banner = {
            script: this.thankYouScript,
            scriptUrl: this.extoleCoreTagUrl
          }
        }
      }).catch(error => {
        this.$notify({
          type: 'error',
          title: extractErrorMessage(error)
        })
      })
    },

    destroyed () {
      if (window.extole) {
        delete window.extole
      }
    }
  }
</script>

<style lang="scss">
  .SubscriptionSuccessful {
    &_body {
      padding: .3rem 0;

      @include media(tablet) {
        padding: .5rem 0;
      }

      .info-product {
        .title {
          font-weight: 700;
          color: $font-black;
        }

        .AppButton {
          background: $blue;

          @include media(tablet) {
            min-width: 3.05rem;
          }
        }
      }

      .partnermessage {
        background: #68b114;
        padding: 5px;
        color: #fff;
        text-align: center;
        margin-bottom: 15px;
        border-radius: 1px;
        font-weight: bold;
        padding-top: 15px;
      }

      .redirecturl {
        color: #0066a1;
        background: none;
        font-weight: bold;
        text-decoration: underline;
        width: 100%;
        margin-bottom: 15px;
      }

      .tips-product {
        margin-bottom: .3rem;
        margin-top: .15rem;

        li {
          font-size: .17rem;
          line-height: .25rem;

          a {
            color: $blue;
          }
        }
      }

      .info-promote {
        img {
          width: 100%;
        }

        .store-app {
          a {
            margin-right: .12rem;
          }
        }
      }
    }

    .FamilyPackOverview {
      .description {
        font-size: .21rem;
        font-weight: 700;
        line-height: .26rem;
        text-align: center;
        margin-bottom: .2rem;

        @include media (tablet) {
          font-size: .24rem;
          font-weight: 700;
          line-height: .3rem;
        }
      }

      .Product {
        border-bottom: .01rem solid #ececec;
        padding: .15rem;
        width: 100%;

        @include media(tablet) {
          margin-bottom: .3rem;
        }

        .Product_info {
          padding: 0 .15rem;
        }

        .img-holder {
          height: 1.03rem;
          width: 1.03rem;
          flex: none;
        }

        .Product_name {
          font-size: .17rem;
          line-height: .22rem;
        }

        .Product_description {
          font-size: .1rem;
          line-height: 1.4;
        }
      }
    }
  }
</style>
